import React, {useContext, useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import Map from '@material-ui/icons/Map';
import BorderOuter from '@material-ui/icons/BorderOuter';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HandymanIcon from '@mui/icons-material/Handyman';
import BarChartIcon from '@mui/icons-material/BarChart';
import { Navigate, useNavigate } from 'react-router-dom';

import { SummaryTabIndex, EquipsTabIndex, MapTabIndex, EventsTabIndex, MainTabPanelIndex,
  ControlTabIndex, CommonChat, AdminTabIndex, DetTunerTabIndex, ServiceTabPanelIndex,
  DetTunerAdminRole, SEUserRole} from '../../model/constants';

import MainToolBar from './MainToolBar';
import MainInfoComponent from './MainInfoComponent';

import {AdminRole} from '../../model/constants'
import { UsersContext } from '../../context/users-context';
import { AppContext } from '../../context/app-context';
import { AllEquipsContext } from '../../context/allEquips-context';
import { EventsContext } from '../../context/events-context';
import { CommunicationContext } from '../../context/communication-context';
import { ControlStateContext} from '../../context/controlState-context';
import { DetTunersContext} from '../../context/dettuners-context';
import * as AdminWorker from '../../workers/adminWorker'
import * as EquipWorker from '../../workers/equipWorker'
import * as ControlWorker from '../../workers/controlWorker'
import * as DetTunerWorker from '../../workers/detTunerWorker'
import {getUSFullDate} from '../../utilities/utils'

const drawerWidth = 240;
const drawerWidthSmall = 60;
const menuItems = [
  { text: "Комплексы", index: EquipsTabIndex },
  { text: "Обзор", index: SummaryTabIndex },
	{ text: "Карта", index: MapTabIndex },
	{ text: "Журнал событий", index: EventsTabIndex },
  { text: "Детекторы", index: DetTunerTabIndex, devider: true },
	{ text: "Панель управления", index: ControlTabIndex, devider: true },
]; // , 'Администрирование'];

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: "column",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    [theme.breakpoints.down(600)]: {
			width: drawerWidthSmall,
		}
  },
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.down(600)]: {
			width: drawerWidthSmall,
		}
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    marginTop: 64, // `${drawerWidth}px`,
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    minWidth: '1300px',
    marginLeft: drawerWidth,
    [theme.breakpoints.down(600)]: {
			marginLeft: drawerWidthSmall,
		}
    // width: `calc(100% - ${drawerWidth}px)`,
  },
  menuText: {
    [theme.breakpoints.down(600)]: {
			display: "none",
		}
  }
}));

export default function MainComponent() {
  const classes = useStyles();  

  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [appState, appDispatch] = useContext(AppContext);
  const [usersState, usersDispatch] = useContext(UsersContext);
  const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);
  const [eventsState, eventsDispatch] = useContext(EventsContext);
  const [controlState, controlDispatch] = useContext(ControlStateContext);
  const [communicationState, communicationDispatch] = useContext(CommunicationContext);
  const [detTunersState, detTunersDispatch] = useContext(DetTunersContext);
  // const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
      (async () => {
        const token = usersState.token;
          if(!token)
          {
            return;
          }

        const allEquips = await EquipWorker.GetAllEquips(token);
				allEquipsDispatch({ type: "SETALLEQUIPS", payload: allEquips });
        if (usersState.currentUser?.Role === DetTunerAdminRole) {
          handleListItemClick(null, DetTunerTabIndex);
        }
        else if (usersState.currentUser?.Role === SEUserRole)
          navigate("/info/equip/service", {state: { tabIndex: EquipsTabIndex, panelIndex: ServiceTabPanelIndex}});
        else    
          navigate("/info/equip/main", {state: { tabIndex: EquipsTabIndex, panelIndex: MainTabPanelIndex}});
      })();
  }, [usersState.token]);

  const token = usersState.token;
  if (!token) {
    return <Navigate to="/" replace/>;  
  }

  const handleListItemClick = async (event, index) => {
    if (isSEUser)
      return;
    
    if(index === EquipsTabIndex || index === MapTabIndex)
    {
      const allEquips = await EquipWorker.GetAllEquips(token);
      allEquipsDispatch({ type: 'SETALLEQUIPS', payload: allEquips });
    }
    else if(index === EventsTabIndex)
    {
      const endDate = new Date();
      const allEvents = await EquipWorker.SearchEquip(token, 'Events', '', getUSFullDate(endDate), getUSFullDate(endDate));
      eventsDispatch({ type: 'SETEVENTS', payload: allEvents }); 
    }    
    else if(index === ControlTabIndex){  
      const state = await ControlWorker.GetServerState(token);
      controlDispatch({ type: 'SETSRVSTATE', payload: state });  

      const notes = await EquipWorker.GetCommunications(token, CommonChat);
      communicationDispatch({ type: 'SETCOMMONCHAT', payload: notes });     
    }
    else if(index === DetTunerTabIndex)
    {
      const tuners = await DetTunerWorker.GetTuners(token);
      detTunersDispatch({ type: 'SETTUNERS', payload: tuners }); 
      const detectors = await DetTunerWorker.GetDetectors(token);
      detTunersDispatch({ type: 'SETDETECTORS', payload: detectors }); 
    }
    else if(index === AdminTabIndex)
    {
      const users = await AdminWorker.GetAllUsers(token);
      usersDispatch({ type: 'SETUSERS', payload: users }); 
    }
  
    MainNavigator(index);
  };

  const selectedTab = appState.currentTab?.tab ?? EquipsTabIndex;
  const isAdmin = usersState.currentUser?.Role === AdminRole;
  const isSEUser = usersState.currentUser?.Role === SEUserRole;
  const mainMenu = isAdmin ? [...menuItems, {text: 'Администрирование', index: AdminTabIndex}] :
                   isSEUser ? [menuItems[0]] :
                   menuItems;

  const getIcon = (tabIndex) => {
    switch (tabIndex)
    {
      case EquipsTabIndex: return <PrecisionManufacturingIcon/>;
      case SummaryTabIndex: return <BarChartIcon/>;
      case MapTabIndex: return <Map/>;
      case EventsTabIndex: return <NotificationsIcon/>;
      case ControlTabIndex: return <HandymanIcon/>;
      case DetTunerTabIndex: return <BorderOuter/>;
      case AdminTabIndex: return <AdminPanelSettingsIcon/>;
      default: return <InboxIcon/>;
    }
  };
  
  return (
    <div className={classes.root}>
      <CssBaseline />
      <MainToolBar></MainToolBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <div className={classes.toolbar} />
        <Divider />
        <List>
          {mainMenu.map((value) => (
            <>
            {value.devider === true ? (<Divider />) : null}
            <ListItem button key={value.text}
                selected={selectedTab === value.index}
                onClick={(event) => handleListItemClick(event, value.index)}
            >
              <ListItemIcon>{getIcon(value.index)}</ListItemIcon>
              <ListItemText className={classes.menuText} primary={value.text} />
            </ListItem>
            </>
          ))}
        </List>
      </Drawer>
      <main className={classes.content}>
          <MainInfoComponent Title={mainMenu[selectedIndex]}></MainInfoComponent>
      </main>
    </div>
  );

  function MainNavigator(index) {
    switch (index) {
      case SummaryTabIndex:
      default:
        navigate("/info/summary/main", { state: { tabIndex: index, panelIndex: MainTabPanelIndex } });
        break;
      case EquipsTabIndex:
        navigate("/info/equip/main", { state: { tabIndex: index, panelIndex: MainTabPanelIndex } });
        break;
      case MapTabIndex:
        navigate("/info/map", { state: { tabIndex: index, panelIndex: MainTabPanelIndex } });
        break;
      case EventsTabIndex:
        navigate("/info/events", { state: { tabIndex: index, panelIndex: MainTabPanelIndex } });
        break;
      case AdminTabIndex:
        navigate("/info/admin", { state: { tabIndex: index, panelIndex: MainTabPanelIndex } });
        break;
      case ControlTabIndex:
        navigate("/info/control/main", { state: { tabIndex: index, panelIndex: MainTabPanelIndex } });
        break;
      case DetTunerTabIndex:
        navigate("/info/detTuner/detector", { state: { tabIndex: index, panelIndex: MainTabPanelIndex } });
        break;
    }
  }
}